import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import { WysiwygField, Image } from '@uncinc/uncinc-react-kitchen-sink';
import { getPathFromAlternativePaths } from '../../../../helpers';

import './style.scss';

const OpinionTeaser = ({ entity, className }) => {
  const classes = classNames(className, 'OpinionTeaser');
  const url = getPathFromAlternativePaths(entity, ['opinion', 'opinie']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={url} className="overlapping-link" />
      <div className="OpinionTeaser__content">
        <div className="OpinionTeaser__contentWrapper">
          <div className="node--sub-heading node--sub-heading--with-labels">
            {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value']) ? (
              <div className="theme-labels">
                <div className="theme-label">
                  {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value'], '')}
                </div>
                {entity.getIn(['field_theme']).size > 1 && (
                  <div className="theme-label">
                    +{entity.getIn(['field_theme']).size - 1}
                  </div>
                )}
              </div>
            ) : null}
            <span>{i18next.t('opinion')}</span>
          </div>
          <h3>{entity.getIn(['title', 0, 'value'])}</h3>
          {entity.getIn(['field_author', 0, 'value']) ? (
            <div className="node--sub-heading-quote">
              — {entity.getIn(['field_author', 0, 'value'])}
            </div>
          ) : null}
        </div>
        <div className="OpinionTeaser__imageWrapper">
          <Image
            alt={entity.getIn(['field_teaser_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_teaser_media', 0, 'styles', 'large'], '')}
          />
        </div>
      </div>
    </article>
  );
};

export default OpinionTeaser;
